import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
export function ScraperHero() {
  const [activeRow, setActiveRow] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveRow(prev => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  const businesses = [{
    name: 'The daily grind coffee co.',
    contact: '+1 212-555-0100',
    email: 'info@dailygrind.com',
    rating: '4.7'
  }, {
    name: 'Fresh bites bakery',
    contact: '+1 310-555-0101',
    email: 'hello@freshbites.com',
    rating: '4.9'
  }, {
    name: 'Urban canvas art studio',
    contact: '+1 415-555-0102',
    email: 'contact@urbancanvas.net',
    rating: '4.5'
  }];
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-1522">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1523">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-1524">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-1525" /> All Features
        </a>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1526">
          {/* Left Column: Copy & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-1527">
            <h1 className="text-6xl sm:text-7xl lg:text-[5.5rem] font-bold tracking-tight text-slate-900 mb-8 leading-[1.05]" data-id="element-1528">
              <span className="text-blue-600" data-id="element-1529">Google Maps</span> <br data-id="element-1530" />
              scraper & <br data-id="element-1531" />
              extractor
            </h1>

            <p className="text-xl sm:text-2xl text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-1532">
              Extract local business data from Google Maps. Get{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-blue-50 text-blue-700 text-lg sm:text-xl font-medium mx-1" data-id="element-1533">
                business emails
              </span>
              ,{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-green-50 text-green-700 text-lg sm:text-xl font-medium mx-1" data-id="element-1534">
                phone numbers
              </span>
              , and{' '}
              <span className="inline-flex items-center px-4 py-1 rounded-full bg-purple-50 text-purple-700 text-lg sm:text-xl font-medium mx-1 mt-2 sm:mt-0" data-id="element-1535">
                reviews & ratings
              </span>{' '}
              in minutes with Openmart.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-1536">
              <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center" data-id="element-1537">
                Try for free
              </a>
            </div>

            {/* Static Stats Bar */}
            <div className="flex gap-12 pt-8" data-id="element-1538">
              <div data-id="element-1539">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-1540">
                  200M+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-1541">
                  Local businesses indexed
                </div>
              </div>
              <div data-id="element-1542">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-1543">
                  50+
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-1544">
                  Data fields per business
                </div>
              </div>
              <div data-id="element-1545">
                <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-1546">
                  Weekly
                </div>
                <div className="text-sm text-slate-500 font-medium" data-id="element-1547">
                  Data updates
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column: Live Data Preview Card */}
          <div className="relative" data-id="element-1548">
            <div className="bg-slate-50 rounded-[2rem] p-8 sm:p-10 relative z-10" data-id="element-1549">
              <div className="flex justify-between items-center mb-8" data-id="element-1550">
                <h3 className="text-2xl font-bold text-slate-900" data-id="element-1551">
                  Google Maps data preview
                </h3>
              </div>

              <div className="overflow-x-auto" data-id="element-1552">
                <table className="w-full text-sm text-left" data-id="element-1553">
                  <thead data-id="element-1554">
                    <tr className="text-slate-400 font-medium border-b border-slate-200/60" data-id="element-1555">
                      <th className="pb-4 pl-4 pr-4 font-medium" data-id="element-1556">
                        Local business
                      </th>
                      <th className="pb-4 px-4 font-medium" data-id="element-1557">Contact info</th>
                      <th className="pb-4 pl-4 font-medium" data-id="element-1558">Email</th>
                      <th className="pb-4 pl-4 font-medium hidden sm:table-cell" data-id="element-1559">
                        Rating
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200/60" data-id="element-1560">
                    {businesses.map((biz, idx) => <tr key={idx} className={`transition-all duration-500 relative ${activeRow === idx ? 'bg-white shadow-sm rounded-xl' : ''}`} data-id="element-1561">
                        <td className="py-6 pl-4 pr-4 font-medium text-slate-900 rounded-l-xl" data-id="element-1562">
                          {biz.name}
                        </td>
                        <td className="py-6 px-4 text-slate-600" data-id="element-1563">
                          <div className="whitespace-nowrap" data-id="element-1564">{biz.contact}</div>
                        </td>
                        <td className="py-6 pl-4 text-blue-600 truncate max-w-[120px] sm:max-w-none" data-id="element-1565">
                          {biz.email}
                        </td>
                        <td className="py-6 pl-4 hidden sm:table-cell rounded-r-xl" data-id="element-1566">
                          <span className="text-slate-600 font-medium" data-id="element-1567">
                            ⭐ {biz.rating}
                          </span>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>

              {/* Export button */}
              <div className="mt-8 pt-6 border-t border-slate-200/60 flex justify-end" data-id="element-1568">
                <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-semibold rounded-lg hover:bg-slate-800 transition-colors" data-id="element-1569">
                  Export data
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}